import { Link as RouterLink } from 'react-router-dom';

// material-ui
import { Link, Stack, Typography } from '@mui/material';

// third-party
import { useIntl } from 'react-intl';

// ==============================|| MAIN LAYOUT - FOOTER ||============================== //

const Footer = () => {
  const intl = useIntl();

  const routes = [
    {
      key: intl.formatMessage({ id: 'common.footer.terms' }),
      path: 'https://www.habihub.com/terms'
    },
    {
      key: intl.formatMessage({ id: 'common.others.privacyPolicy' }),
      path: 'https://www.habihub.com/privacy-policy'
    },
    {
      key: intl.formatMessage({ id: 'common.footer.legalNotice' }),
      path: 'https://www.habihub.com/legal-notice'
    }
  ];
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ p: '24px 16px 0px', mt: 'auto' }}>
      <Typography variant="caption">&copy; {new Date().getFullYear()} HabiHub</Typography>
      <Stack spacing={1.5} direction="row" justifyContent="space-between" alignItems="center">
        {routes.map((route, index) => (
          <Link key={index} component={RouterLink} to={route.path} target="_blank" variant="caption" color="textPrimary">
            {route.key}
          </Link>
        ))}
      </Stack>
    </Stack>
  );
};

export default Footer;
